// util/parseJson.js
export function parseJsonField(field) {
    if (typeof field === 'string') {
      try {
        return JSON.parse(field)
      } catch {
        return []
      }
    }
    return Array.isArray(field) ? field : []
  }
  